
import { defineComponent, onMounted, reactive, ref, toRefs, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElTable } from 'element-plus'

export default defineComponent({
  props: {
    tableData: {
      type: Array,
      required: true
    },
    columnStruct: {
      type: Array,
      required: true
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    hadOperate: {
      type: Boolean,
      required: false,
      default: true
    },
    operateText: {
      type: String,
      required: false,
      default: 'common.operate'
    },
    operateColumnWidth: {
      type: Number,
      required: false,
      default: 180
    },
    hadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    },
    defaultSelect: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const { t } = useI18n()
    const tableRef = ref(ElTable)
    const dataMap = reactive({
      selectedRow: 0,
      defaultSelect: 0
    })
    const handleRadioChange = (row: any) => {
      dataMap.selectedRow = row.id
    }
    const handleRowClick = (row: any) => {
      dataMap.selectedRow = row.id
    }
    const setSelectedRow = (id: any) => {
      dataMap.selectedRow = id
      dataMap.defaultSelect = id
    }
    const getSelectionRow = () => {
      return dataMap.selectedRow || null
    }
    const clearSelection = () => {
      if (tableRef.value) {
        tableRef.value.clearSelection()
        dataMap.selectedRow = 0
      }
    }
    onMounted(() => {
      dataMap.selectedRow = props.defaultSelect
    })
    watch(() => dataMap.defaultSelect, value => {
      dataMap.selectedRow = value
    })
    return {
      t,
      tableRef,
      handleRadioChange,
      handleRowClick,
      setSelectedRow,
      getSelectionRow,
      clearSelection,
      ...toRefs(dataMap)
    }
  }
})
